<core-generic-table
  [endpoint]="endpoint"
  [listTitle]="'countryHolidays.title' | translate"
  [columns]="columns"
  [modalTabs]="modalFields()"
  [actions]="actions"
  [globalActions]="globalActions"
  [showFilter]="true"
  [showActiveFilters]="true"
  [customFilters]="customFilters()"
  [showSelection]="false"
  [showActions]="true"
  [showCreateButton]="true"
  [enablePagination]="true"
  [onApiError]="handleApiError"
  [modelFactory]="countryHolidayModelFactory"
  (onFilterChange)="onFilterChange($event)"
  (onClearFilters)="onFilterChange()"
  class="o-layout__section">
</core-generic-table>
